import {
  AirplaneIcon,
  BuildingsIcon,
  TriangleIcon,
  UsersIcon,
} from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import { IconTrips } from "@/components/Icons";

import "./animatedLoader.css";

const iconMap = {
  airplane: AirplaneIcon,
  buildings: BuildingsIcon,
  users: UsersIcon,
};

type Props = { icon: keyof typeof iconMap | "trip" };

function Icon({ icon }: Props) {
  if (icon === "trip") {
    return (
      <IconTrips
        className="absolute z-10 size-9 text-surface-accent-stronger"
        aria-hidden
      />
    );
  }

  const IconComponent = iconMap[icon] || AirplaneIcon;

  return (
    <IconComponent
      size={40}
      color="var(--color-surface-accent-stronger)"
      className="absolute z-10"
    />
  );
}

export function AnimatedLoader({ icon }: Props) {
  const intl = useIntl();

  return (
    <div
      className="relative flex h-[68px] w-[68px] flex-col items-center justify-center"
      role="status"
      aria-label={intl.formatMessage({
        id: "loading",
        defaultMessage: "Loading",
      })}
    >
      <TriangleIcon
        size={10}
        weight="fill"
        className="top-arrow absolute text-surface-accent-stronger/50"
        aria-hidden
      />

      <TriangleIcon
        size={10}
        weight="fill"
        className="bottom-arrow absolute text-surface-accent-stronger/50"
        aria-hidden
      />

      <Icon icon={icon} />
    </div>
  );
}
